<template>
  <div class="page">
    <HeaderNav :topLevel="true" actId="1" :headTitle="headTitle"/>
    <div class="container">
      <div class="bannel">
        <div class="ball ball-left" ref="ball1" :style="getBallStyle1"></div>
        <div class="ball ball-mid" ref="ball2" :style="getBallStyle2"></div>
        <div class="ball ball-right" ref="ball3" :style="getBallStyle3"></div>
        <div class="l">
          <div class="l-top">
            <h2>朗朗书声语文朗读教学平台</h2>
          </div>
          <div class="desc b">（诵读资源库）</div>
         <!--  <div class="desc">人民教育电子音像出版社 中教思达（北京）教育科技有限公司</div> -->
        </div>
        <div class="m-box">
          <div class="date-time">
            <em>{{timeInfo.time}}&nbsp;{{curTime}}</em>
            <span v-if="timeInfo.msg" v-text="timeInfo.msg">现在是晨读时间</span>
          </div>
          <div class="btns">
            <button @click="toDetail(1)" class="btn" :class="{'actived': btnType == 2}">
              <i class="icon icon-ring"></i>
              <span>语文教材</span>
            </button>
            <button @click="toDetail(2)" class="btn btn-sed" :class="{'actived': btnType == 1}">
              <i class="icon icon-ring"></i>
              <span>诵读资源</span>
            </button>
          </div>
          <div class="carousel-box">
            <i class="icon-tips"></i>
            <carousel :list="messageList" keyName="slogan"></carousel>
          </div>
        </div>
      </div>
      <div class="stat">
        全国<em>
          <count-up v-if="getStatInfo.teacherCnt" :endnum="getStatInfo.teacherCnt" duration="1" decimals="0" /></em>名教师正在使用“朗朗书声语文朗读教学平台（诵读资源库）”进行辅助教学
      </div>
      <div class="prod">
        <div class="xiaoniao" ref="xiaoniao">
          <div class="chibang" ref="chibang"></div>
        </div>
        <div class="con">
          <h2>
            <span>
              功能特点
            </span>
          </h2>
          <ul class="list">
            <li :class="[item.className]" v-for="(item, index) in proList" :key="index">
              <div class="t-bg">
                <i class="icon"></i>
              </div>
              <div class="title">{{item.name}}</div>
              <div class="desc" v-html="item.desc"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="left">
        <div class="copy">
          Copyright @ 2020 朗朗书声 All Right Reserved <br><a href="http://www.beian.miit.gov.cn">京ICP备19040061号</a>
        </div>
        <div class="wj">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040926" style="display:inline-block;">
          <img src="~images/icon-wj.png" style="float:left;" />
          <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; ">京公网安备 11010502040926号</p>
        </a>
        </div>
      </div>
      <div class="qrcode">
        <img class="img" src="~images/qrcode.jpg">
        <div class="qrcode-layer">
          <div class="box">
            <div class="title">
              全国 <em v-text="getStatInfo.teacherCnt"></em> 名教师 <em v-text="getStatInfo.studentCnt"></em> 名学生，正在小程序中布置/完成朗读作业
            </div>
            <ul>
              <li>
                <img src="~images/qrcode1.jpg">
              </li>
              <li class="split"></li>
              <li>
                <img src="~images/qrcode.jpg">
              </li>
            </ul>
            <p class="f">
              微信搜索【朗朗书声丨统编人教语文朗读指导】公众号和小程序
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAudio">
      <AudioManager v-show="false" ref="audio" :options="audioOptions" />
    </div>
    <div class="popup_box" v-if="isShowLimitPopup" catchtouchmove="true">
      <div class="popup_content">
        <div class="popup_title">朗朗书声  温馨提示</div>
        <div class="p_content">你的朗朗书声机构版账号已失效，请联系学校管理员老师协助处理~</div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import util from 'libs/util'
import CountUp from 'base/ydcountup';
import AudioManager from 'business/AudioManager'
import Carousel from 'base/carousel';
import 'web-animations-js'
import xiaoNiao1 from 'images/xiaoniao/1.png';
import xiaoNiao2 from 'images/xiaoniao/2.png';


export default {
  components: {
    CountUp,
    Carousel,
    AudioManager
  },
  data() {
    return {
      proList: [{
        id: 1,
        name: '课文范读',
        desc: '名家示范&nbsp;精美朗读',
        className: 'fandu'
      }, {
        id: 2,
        name: '朗读指导',
        desc: '要点讲解&nbsp;快速提升',
        className: 'zhidao'
      }, {
        id: 3,
        name: '跟读练习',
        desc: '边听边读&nbsp;逐步提高',
        className: 'gendu'
      }, {
        id: 4,
        name: '逐句训练',
        desc: '单句点读&nbsp;循序渐进',
        className: 'zhuju'
      }, {
        id: 5,
        name: '生字生词',
        desc: '听音识字&nbsp;规范书写',
        className: 'szsc'
      }, {
        id: 6,
        name: '诵读书库',
        desc: '海量资源&nbsp;拓展阅读',
        className: 'cd'
      }],
      curTime: '',
      btnType: -1,
      statInfo: {},
      timeInfo: {
        time: '',
        msg: ''
      },
      showAudio: false,
      messageList: [],
      audioOptions: {
        src: require('assets/index.mp3'),
        autoplay: true
      },
      ticket: '',
      platformcode: '',
      isShowLimitPopup: false,
      orgaDatas: null, // 机构信息
      headTitle: '朗朗书声',
    }
  },
  computed: {
    getBallStyle1() {
      let radioStyle = this.getRectStyle({
        top: -76,
        left: -66,
        width: 220,
        height: 220
      })
      return radioStyle
    },
    getBallStyle2() {
      let radioStyle = this.getRectStyle({
        top: 63,
        left: 702,
        width: 199,
        height: 199
      })
      return radioStyle
    },
    getBallStyle3() {
      let radioStyle = this.getRectStyle({
        right: -192,
        width: 220,
        height: 220
      })
      return radioStyle
    },
    ...mapGetters([
      'getStatInfo',
      'getClientWidth'
    ])
  },
  created() {
    if (!util.cookie('BG_AUDIO_ISPLAY')) {
      this.showAudio = true;
      util.cookie('BG_AUDIO_ISPLAY', 1);
    }
    this.getTimeInfo();
    this.getSlogan();
  },
  mounted() {
    const query = this.$route.query;
    if (util.getStorage('orgaId') && query.orgaId && (Number(query.orgaId) != Number(util.getStorage('orgaId'))) || (!util.getStorage('orgaId') && query.orgaId && util.getStorage('LLSS_TOKEN'))) { // 如果本地已经存有机构了且该机构不等于当前进来的机构 || 一登陆了平台且点击机构链接
      util.removeStorage('LLSS_TOKEN')
      util.removeStorage('orgaId')
      util.removeStorage('orgaDatas')
    }
    if (query && query.orgaId) {// 检测是否有带机构id
      util.setStorage('orgaId', query.orgaId) // 
    } else {
      if (util.getStorage('orgaId')) { // 没有带机构id则是平台
        util.removeStorage('orgaId')
        util.removeStorage('orgaDatas')
      }
    }
    if (util.getStorage('LLSS_TOKEN') && util.getStorage('orgaId')) {
        this.checkedOrga()
    }
    this.ticket = query.ticket||null;
    this.platformcode = query.platformcode;
    if(this.ticket){
      this.thirdUserLogin();
    }
    this.initBall();
    this.initXiaoNiao();
  },
  methods: {
    // 查找机构信息
    checkedOrga () {
      let url = `/passport/orgainfo.json`
      this.$post(url, {}).then((res) => {
        let orgaDatas = res.data
        this.headTitle = res.data.orgaName
        this.isShowLimitPopup = res.data.expireNum
        util.setStorage('orgaDatas', orgaDatas)
      }).catch((e) => {
        console.log(e)
      })
    },
    getRectStyle(rect) {
      let clientWidth = this.getClientWidth;
      if (clientWidth < 1440) {
        clientWidth = 1440;
      }
      let radio = clientWidth / 1440;
      Object.keys(rect).forEach((key) => {
        rect[key] = (rect[key] * radio).toFixed(0) + 'px'
      });
      return rect
    },
    initBall() {
      let ball1 = this.$refs.ball1;
      let ball2 = this.$refs.ball2;
      let ball3 = this.$refs.ball3;
      let ballOptions = {
        direction: 'alternate',
        duration: 8000,
        iterations: Infinity
      }
      ball1.animate({
        transform: ['translate(-20px,-10px)', 'translate(0,0)', 'translate(5px,0)'],
        opacity: [.5, 1, .6, 1]
      }, ballOptions);

      ball2.animate({
        transform: ['translate(-20px,-10px)', 'translate(0,0)', 'translate(20px,0)'],
        opacity: [.5, 1, .6, 1]
      }, ballOptions);

      ball3.animate({
        transform: ['translate(-20px,-10px)', 'translate(0,0)', 'translate(5px,0)']
      }, ballOptions);
    },
    initXiaoNiao() {
      let duration = this.getClientWidth * 18 / 1600;
      if (duration < 10) {
        duration = 10;
      }
      let chibang = this.$refs.chibang;
      let xiaoniao = this.$refs.xiaoniao;
      chibang.animate({
        background: ['url(' + xiaoNiao1 + ')', 'url(' + xiaoNiao2 + ')'],
      }, {
        direction: 'alternate',
        duration: 150,
        iterations: Infinity,
        easing: 'linear'
      });
      xiaoniao.animate({
        left: [0, '10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'],
        top: [0, '20px', '15px', '10px', '0', '20px', '-25px', '0', '25px', '0', '-25px']
      }, {
        duration: duration * 1000,
        iterations: Infinity,
      });
    },
    async getSlogan() {
      const res = await this.$post('/slogan/all.json', {});
      if (res.status == 200) {
        const data = res.data;
        if (data) {
          this.messageList = data
        }
      }
    },
    mouseenterHandler() {
      this.$refs.audio && this.$refs.audio.play()
    },
    toDetail(type) {
      if (type == 1) {
        let id = util.getStorage('LLSH_LAST_WARE');
        this.$gopage('book_ware', {
          id
        })
      } else {
        this.$gopage('book_library')
      }
    },
    getTimeInfo() {
      let d = new Date();
      let hour = d.getHours();
      let day = d.getDay();
      let msg = '';
      let btnType = -1;
      let fullDate = util.date.format(d, 'yyyy-MM-dd');
      let week = ['日', '一', '二', '三', '四', '五', '六'][day];
      let morning = '';
      if (hour >= 7 && hour <= 12) {
        morning = "上午"
      }
      if (hour > 12 && hour <= 18) {
        morning = "下午"
      }
      if ((hour > 18 && hour <= 23)) {
        morning = "晚上"
      }
      if (hour >= 0 && hour <= 6) {
        morning = "凌晨"
      }
      if (day && day != 6) {
        if (hour >= 7 && hour < 9) {
          msg = '现在是晨读时间'
          btnType = 1;
        }
        if (hour >= 9 && hour < 17) {
          msg = '现在是上课时间'
          btnType = 2;
        }
      }
      this.btnType = btnType;
      this.timeInfo = {
        time: `${fullDate} 星期${week} ${morning}`,
        msg
      }
      const getCurTime = () => {
        this.curTime = util.date.format(new Date(), 'HH:mm:ss');
      }
      getCurTime();
      let t = setInterval(() => {
        getCurTime()
      }, 1000)
    },
    async thirdUserLogin(){
      let param={
        ticket: this.ticket,
        platformcode: this.platformcode
      };
      const res = await this.$get('/passport/tianYuLogin.json', param);
      const query = this.$route.query;
      if(res.status == 200){
        const user = await this.$store.dispatch('queryUserInfo');
        console.log(1,user);
      }
    },
  }
}
</script>
<style lang="less" scoped>
@import '~styles/index.less';
.container{
  overflow-y: auto;
}
.popup_box{
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  .popup_content{
    width: 360px;
    height: 180px;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 16px;
    padding: 26px;
    box-sizing: border-box;
    text-align: center;
    .popup_title{
      font-size: 20px;
      font-weight: bold;
    }
    .p_content{
      font-size: 16px;
      margin-top: 22px;
    }
  }
}
</style>